import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCart } from "../../redux/features/cartSlice";

import { useParams, useNavigate } from "react-router-dom";
import { generateOrder } from "../../redux/features/generateKlarnaSlice";
import DOMPurify from "dompurify";

function PayKlarna() {

  const { order_ids } = useParams();


  const { order } = useSelector((state) => state.klarna);

  const dispatch = useDispatch();

  useEffect(() => {
    if (order_ids) {
      dispatch(generateOrder(order_ids));
    }
  }, [dispatch, order_ids]);

  return <div id="my-checkout-container"></div>;

}

export default PayKlarna;
